import { DP_NEWS_LIST_FEATURE } from './news-list-state.type';

export enum NEWS_LIST_ACTIONS {
  LOAD_NEWS = `${DP_NEWS_LIST_FEATURE} LOAD_NEWS`,
  LOAD_NEWS_SUCCESS = `${DP_NEWS_LIST_FEATURE} LOAD_NEWS_SUCCESS`,
  SHOW_MORE = `${DP_NEWS_LIST_FEATURE} SHOW_MORE`,
  NEWS_PAGE_RESIZE = `${DP_NEWS_LIST_FEATURE} NEWS_PAGE_RESIZE`,
}
